module.exports = __webpack_public_path__ + "18d4605f22b3b45bc8e2a340c827f0ad.pdf";